import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  initialize() {
    this.element.addEventListener('keydown', this.constructor.handleNumpadKeys);
  }

  static handleNumpadKeys(e) {
    const re = /^Numpad(\d|Decimal)$/;

    if (!re.test(e.code) || (e.key >= '0' && e.key <= '9')) {
      return;
    }

    e.preventDefault();

    let entered = '';
    if (e.code === 'NumpadDecimal') {
      entered = '.';
    } else {
      [, entered] = e.code.match(re);
    }

    const input = e.target;
    const { value, selectionStart: start, selectionEnd: end } = input;

    input.value = value.substr(0, start) + entered + value.substr(end);
    input.setSelectionRange(start + 1, start + 1);
  }
}
